import React, { Component } from "react";
import Navigations from "../../config/navbar";
import Footer from "../../components/footer";
import "bootstrap/dist/css/bootstrap.css";
class Books extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
      // class=" d-flex flex-row align-items-center"
      // style={{ background: " #dedede ", minHeight: "100vh" }}
      >
        <Navigations />
        <div
          style={{
            borderBottom: "3px solid black",
            textAlign: "center",
            marginTop: "5rem",
          }}
        >
          <h1 style={{ color: "rgb(118, 102, 223)" }}>My Youtube Videos</h1>
          <h4 style={{ color: "rgb(118, 102, 223)" }}>
            I’ve been designing videos for my projects.
          </h4>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-md-6 mt-4 mb-4">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe
                  class="embed-responsive-item"
                  src={`https://www.youtube.com/embed/R704Yp61vao`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Embedded youtube"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-6 mt-4 mb-4">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe
                  class="embed-responsive-item"
                  src={`https://www.youtube.com/embed/ZvevRhxZygA`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Embedded youtube"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-6 mt-4 mb-4">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe
                  class="embed-responsive-item"
                  src={`https://www.youtube.com/embed/z9by8ZIT2yY`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Embedded youtube"
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Books;
